module.exports = __webpack_public_path__ + "085a6cde73165101e11790ad94985701.MP3";